export const Props = () => ({
  //Скрыть бар с ползунком
  isHideBar: { 
    type: Boolean,
    default: false,
  },
});